import { render, staticRenderFns } from "./newMV.vue?vue&type=template&id=39f38761&scoped=true"
import script from "./newMV.vue?vue&type=script&lang=js"
export * from "./newMV.vue?vue&type=script&lang=js"
import style0 from "./newMV.vue?vue&type=style&index=0&id=39f38761&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f38761",
  null
  
)

export default component.exports